var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLightning = function SvgLightning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M18.94 9.734a.4.4 0 0 0-.363-.224h-6.078l1.54-6.968a.43.43 0 0 0-.239-.507.41.41 0 0 0-.502.141L5.06 13.804a.41.41 0 0 0 0 .432.41.41 0 0 0 .338.258h6.078l-1.54 6.968a.43.43 0 0 0 .24.507.424.424 0 0 0 .502-.142L18.915 10.2a.41.41 0 0 0 .024-.466"
  })));
};
export default SvgLightning;